import { render, staticRenderFns } from "./BackgroundImg.vue?vue&type=template&id=0570c6a3&"
import script from "./BackgroundImg.vue?vue&type=script&lang=js&"
export * from "./BackgroundImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\PlentyMarkets\\16982\\163\\CeresCoconut\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0570c6a3')) {
      api.createRecord('0570c6a3', component.options)
    } else {
      api.reload('0570c6a3', component.options)
    }
    module.hot.accept("./BackgroundImg.vue?vue&type=template&id=0570c6a3&", function () {
      api.rerender('0570c6a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/common/BackgroundImg.vue"
export default component.exports